import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { UserTableComponent } from './demo/view/usertable.component';
import { UserEditComponent } from './demo/view/useredit.component';
import { CompanyTableComponent } from './demo/view/company-table.component';
import { CompanyEditComponent } from './demo/view/company-edit.component';
import { ReportDefinitionTableComponent } from './demo/view/reportdefinition-table.component';
import { ReportDefinitionEditComponent } from './demo/view/reportdefinition-edit.component';
import { AuthGuardService as AuthGuard } from './demo/service/authguardservice';
import { UserRestrictedEditComponent } from './demo/view/user-restricted.edit.component';
import { AllocationFactorsEditComponent } from './demo/view/allocation-factors-edit.component';
import { AllocationFactorsImportComponent } from './demo/view/allocation-factors-import.component';
import { AllocationDefinitionTableComponent } from './demo/view/allocation-definition-table.component';

export const routes: Routes = [
    {
        path: '',
        component: AppMainComponent,
        children: [
            {
                path: '',
                component: ReportDefinitionTableComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'users',
                component: UserTableComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'users/:id',
                component: UserEditComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'usersrestricted/:id',
                component: UserRestrictedEditComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'companies',
                component: CompanyTableComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'companies/:id',
                component: CompanyEditComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'reportdefinitions',
                component: ReportDefinitionTableComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'reportdefinitions/:id',
                component: ReportDefinitionEditComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'allocationdefinitions',
                component: AllocationDefinitionTableComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'allocationfactors/:id',
                component: AllocationFactorsEditComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'allocationfactorsimport',
                component: AllocationFactorsImportComponent,
                canActivate: [AuthGuard]
            }
        ]
    },
    { path: 'error', component: AppErrorComponent },
    { path: 'accessdenied', component: AppAccessdeniedComponent },
    { path: '404', component: AppNotfoundComponent },
    { path: 'login', component: AppLoginComponent },
    { path: '**', redirectTo: '/404' }
];

export const AppRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
});
